import axios from "axios";

export interface ValidatedZipcode {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
}

export function zipcode(input: string) {
  const validated = Promise.any([
    viacep(input),
    opencep(input),
  ]);

  return validated;
}

function viacep(cep: string): Promise<ValidatedZipcode> {
  cep = cep.replace(/\D/g, "");

  return axios.get<ValidatedZipcode | { erro: boolean }>(`https://viacep.com.br/ws/${cep}/json/`).then((res) => {
    if ("erro" in res.data && res.data.erro) {
      throw new Error("Invalid zipcode from ViaCEP");
    }
    return res.data as ValidatedZipcode;
  });
}

function opencep(cep: string): Promise<ValidatedZipcode> {
  cep = cep.replace(/\D/g, "");

  return axios.get<ValidatedZipcode>(`https://opencep.com/v1/${cep}`).then((res) => {
    if (!res.data?.cep) {
      throw new Error("Invalid zipcode from OpenCEP");
    }
    return res.data;
  });
}
